import { Spark, SparkStoreInterface, SparkCache, SparkCacheMetadata } from 'sparkello-core';
import store from '@/store';
import { auth } from 'firebase/app';

export class VuexSparkStore implements SparkStoreInterface {
  //Retrieves the list of Sparks from the state store
  public getSparks(): Spark[] {
    // return store.state.sparks;
    return [];
  }

  //Sets the entire list of Sparks in the state store
  public setSparks(sparks: Spark[]): void {
    // store.commit('setSparks', sparks);
  }
x
  //Sets the entire list of Sparks in the state store
  public getSparkCache(): SparkCache {
    return store.state.sparkCache;
  }

  //Sets the entire list of Sparks in the state store
  public getSparkCacheInfo(): SparkCacheMetadata {
    return store.state.sparkCacheInfo;
  }

  //Sets the entire list of Sparks in the state store
  /**
   * Update the state store with Sparks data
   * @param sparks The array of Sparks from the server
   * @param source The source of the data - Firestore server or Firestore cache
   */
  public setSparkCache(sparks: Spark[], source: 'server' | 'cache'): void {

    const sparkCache = new SparkCache(sparks);
    sparkCache.addSparksToDisplay(12);

    const sparkCacheInfo = new SparkCacheMetadata(new Date().getTime(), auth()?.currentUser?.uid);

    //If the source of the data was from the Firestore cache, then ensure the lastServerRefresh is not reset
    if (source == 'cache') {
      sparkCacheInfo.lastServerRefresh = this.getSparkCacheInfo().lastServerRefresh;
    }

    console.log('Spark Cache', sparkCache, sparkCacheInfo);
    store.commit('setSparkCache', sparkCache);
    store.commit('setSparkCacheInfo', sparkCacheInfo);
  }
}
